import {
  Loader,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Notification,
  NotificationType,
} from "@transfr-inc/dashboard-components";
import { Button } from "@transfr-inc/dashboard-components/forms";

import { TagItem } from "@components/custom/dropdowns";
import { useDeleteOrganizationTag } from "@hooks/queries";

export const DeleteTagSlide = ({ organizationCode, tag, onBack, onDone }) => {
  const {
    mutateAsync: deleteDeviceTag,
    isPending,
    isError,
    reset,
  } = useDeleteOrganizationTag(organizationCode);

  const handleBack = () => {
    reset();
    onBack?.();
  };

  const handleConfirmClick = async () => {
    await deleteDeviceTag(tag?.id);
    reset();
    onDone?.();
  };

  return (
    <>
      {isPending && <Loader overlay />}
      <ModalHeader
        className="red-icon"
        icon={["fa-regular", "trash-can"]}
        title="Delete Tag"
      />
      <ModalBody>
        {isError && (
          <Notification type={NotificationType.error}>
            Something went wrong. Please try again.
          </Notification>
        )}
        <p>
          Are you sure that you would like to delete the following tag? This
          will remove the tag from all devices.
        </p>
        <TagItem value={tag} />
      </ModalBody>
      <ModalFooter>
        <Button onClick={handleBack}>Cancel</Button>
        <Button destructive onClick={handleConfirmClick}>
          Yes, Delete Tag
        </Button>
      </ModalFooter>
    </>
  );
};
